<template>
    <el-carousel :height="bannerHeight" :interval="interval" :arrow="arrow" class="responsive-carousel"
        :autoplay="autoplay">
        <el-carousel-item v-for="item in banners" :key="item.id">
            <div class="carousel-item">
                <img :src="item.img" :alt="item.alt || '配送服务'">
            </div>
        </el-carousel-item>
    </el-carousel>
</template>

<script>
export default {
    name: 'BannerCarousel',
    props: {
        // 轮播图数据
        banners: {
            type: Array,
            default: () => []
        },
        // 轮播间隔时间（毫秒）
        interval: {
            type: Number,
            default: 5000
        },
        // 箭头显示方式：hover, always, never
        arrow: {
            type: String,
            default: 'hover'
        },
        // 是否自动播放
        autoplay: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            // 轮播图高度
            bannerHeight: '40vh'
        }
    },
    mounted() {
        // 监听窗口大小变化，调整轮播图高度
        window.addEventListener('resize', this.handleResize);
        // 初始化时设置轮播图高度
        this.handleResize();

    },
    methods: {
        // 处理窗口大小变化
        handleResize() {
            // 智能调整主轮播图高度
            const width = window.innerWidth;
            if (width < 480) {
                this.bannerHeight = '20vh';
            } else if (width < 768) {
                this.bannerHeight = '30vh';
            } else if (width < 1200) {
                this.bannerHeight = '40vh';
            } else {
                this.bannerHeight = '50vh';
            }
        }
    }
}
</script>

<style scoped>
/* 轮播图样式 */
.carousel-item {
    position: relative;
    height: 100%;
    overflow: hidden;
}

.carousel-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}

.carousel-item:hover img {
    transform: scale(1.05);
}

/* 轮播图响应式设置 */
.responsive-carousel {
    /* 高度将通过props动态控制 */
    transition: height 0.3s ease;
}

/* 修改轮播图箭头颜色 */
.responsive-carousel>>>.el-carousel__arrow {
    background-color: rgba(0, 0, 0, 0.5);
    color: #ffffff;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    font-size: 18px;
}

.responsive-carousel>>>.el-carousel__arrow:hover {
    background-color: rgba(0, 0, 0, 0.7);
    color: #ffffff;
}
</style>